import React, { useEffect } from 'react';
import './AssetUpload.scss';
import UploadContainer from 'componentsV2/AssestUpload/UploadContent/UploadContent';
import { dropdownOptionsAction } from 'actions/dropdownOptions';
import { DROPDOWN_OPTIONS_RESET } from 'constants/actionTypes';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { useDispatch } from 'react-redux';

const AssetUpload = () => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  useEffect(() => {
    dispatch(
      dropdownOptionsAction.updateDropdownOptions(
        DROPDOWN_OPTIONS_RESET,
        {},
        ''
      )
    );
  });
  useEffect(() => {
    document.title = 'Asset Upload';
  }, []);
  return (
    <div className="asset-upload" data-testid="asset-upload-page">
      <div className="page-title">Upload Assets</div>
      <UploadContainer />
    </div>
  );
};

export default AssetUpload;
